/**
 * Needs you's rail (WS-22): a button per section with its count — a click
 * moves to the section's first item — and what release waits on: "Release
 * waits on N" (the live draft's open errors), "Nothing holds release", or
 * nothing where the workbench doesn't release the case.
 */

import { Button, Group, Text } from '@mantine/core';

import { SECTION_NAMES, type Section } from '@/types/workbench';
import type { NeedsYouSection } from './needsYouOrder';
import { Kbd } from './panes/common';
import classes from './NeedsYou.module.css';

interface NeedsYouRailProps {
  sections: NeedsYouSection[];
  releaseWaitsOn: string[] | null;
  onSection: (section: Section) => void;
}

export function NeedsYouRail({ sections, releaseWaitsOn, onSection }: Readonly<NeedsYouRailProps>) {
  return (
    <Group gap="xs" wrap="wrap" className={classes.rail} data-testid="needs-you-rail">
      {sections.map((s) => (
        <Button
          key={s.section}
          size="compact-xs"
          variant="light"
          color="orange"
          onClick={() => onSection(s.section)}
          data-testid={`rail-${s.section}`}
        >
          {SECTION_NAMES[s.section]} {s.count.toLocaleString()}
        </Button>
      ))}
      {releaseWaitsOn !== null && (
        <Text
          size="xs"
          fw={600}
          c={releaseWaitsOn.length > 0 ? 'red.7' : 'teal.7'}
          data-testid="release-status"
        >
          {releaseWaitsOn.length > 0
            ? `Release waits on ${releaseWaitsOn.length}`
            : 'Nothing holds release'}
        </Text>
      )}
      <Text size="xs" c="dimmed" ml="auto">
        <Kbd>j</Kbd> next · <Kbd>k</Kbd> previous
      </Text>
    </Group>
  );
}
